const type = 'SET_CARD_PARAM_VALUE';

const setCardParamValue = (data) => ({
  type,
  data,
});

export default setCardParamValue;
